import {ResourceConfig} from "@hidat/huijs-resource";
import {FieldConfig, FieldDataTypes, nString, uBoolean, uNumber, uString, Uuid} from "@hidat/huijs-common";
import {LocalDate, ZonedDateTime} from "@js-joda/core";
import {RblFieldConfigs, RblTenantResourceInterface} from "../rbl-resource.interface";

export const ChangeSetConfig = new ResourceConfig('ChangeSet', 'change-sets', true, true)
  .addFields([
    RblFieldConfigs.id,
    RblFieldConfigs.uid,
    RblFieldConfigs.list,
    RblFieldConfigs.library.setEditable(true),
    RblFieldConfigs.createdAt,
    RblFieldConfigs.name,
    new FieldConfig('wfStatus', FieldDataTypes.NUMBER),
    new FieldConfig('approvedAt', FieldDataTypes.DATETIME).setEditable(false),
    new FieldConfig('approvedById', FieldDataTypes.UID).setEditable(false),
    new FieldConfig('completedAt', FieldDataTypes.DATETIME).setEditable(false),
    new FieldConfig('completedById', FieldDataTypes.UID).setEditable(false),
    new FieldConfig('startsOn', FieldDataTypes.DATE),
    new FieldConfig('endsOn', FieldDataTypes.DATE),
    new FieldConfig('effectiveDate', FieldDataTypes.DATE).setEditable(false),
    new FieldConfig('rotationStatus', FieldDataTypes.INTEGER, true, "TARGET_ROTATION_STATUS"),
    new FieldConfig('category'),
    new FieldConfig('swapCategories', FieldDataTypes.BOOLEAN),
    new FieldConfig('notes'),
  ])
  .setSorts({
    name: 'name',
    createdat: 'createdAt'
  })
  .setDefaultSort('name')

export enum ChangeSetStatus {
  ERROR = -100,
  PENDING = 0,
  APPROVED = 50,
  COMPLETED = 100,
}

export interface ChangeSetInterface extends RblTenantResourceInterface {
  uid: Uuid | undefined;
  listId: uNumber;
  name: uString;
  libraryId: uNumber;
  wfStatus: uNumber;
  approvedAt: ZonedDateTime | undefined;
  approvedById: Uuid | undefined;
  completedAt: ZonedDateTime | undefined;
  completedById: Uuid | undefined;
  effectiveDate: LocalDate | undefined;
  startsOn: LocalDate | undefined | null;
  endsOn: LocalDate | undefined | null;
  rotationStatus: uString;   //@TODO: Why is this string, and item is number.  BAD CRAIG!
  category: nString;
  swapCategories: uBoolean;
  notes: nString;
}
